import { Link, useLocation } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面未找到 - 森泽佳奈官网",
    description: "抱歉，您访问的页面不存在，请返回首页浏览森泽佳奈的最新资讯与作品。",
  });

  return (
    <div className="px-4 md:px-8 py-20 md:py-28 flex flex-col items-center justify-center text-center bg-background-50">
      <span className="font-heading text-7xl md:text-9xl font-bold text-background-300 select-none">
        404
      </span>
      <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-4">
        抱歉，页面不存在
      </h1>
      <p className="text-sm text-foreground-500 mt-2 font-mono break-all">{location.pathname}</p>
      <p className="text-sm text-foreground-600 mt-3 max-w-md">
        您访问的页面可能已被移动或暂时不可用，不妨返回首页，继续浏览森泽佳奈的最新资讯与作品。
      </p>
      <div className="flex flex-col sm:flex-row gap-3 mt-7">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-newspaper-line"></i>
          浏览最新资讯
        </Link>
      </div>
    </div>
  );
}